import Card from "components/card";
import { useDealData } from "contexts/DealContext";
import { usePortfolioData } from "contexts/PortfolioContext";
import { useViewMode } from "contexts/ViewModeContext";
import BarChart from "./BarChart";

const NursingHPPD = () => {
    const { viewMode } = useViewMode();

    // Deal data
    const { currentFacility: dealFacility } = useDealData();

    // Portfolio data
    const { currentPortfolioFacility } = usePortfolioData();

    // Use appropriate data based on view mode
    const currentFacility = viewMode === 'portfolio' ? currentPortfolioFacility : dealFacility;
    const noData = !currentFacility?.details?.["Nursing HPPD- Actual"] &&
        !currentFacility?.details?.["Nursing HPPD - Actual"] &&
        !currentFacility?.details?.["Nursing HPPD- Expected"] &&
        !currentFacility?.details?.["Nursing HPPD - Expected"] &&
        !currentFacility?.details?.["Nursing HPPD- Weekend"] &&
        !currentFacility?.details?.["Nursing HPPD - Weekend"];

    const formatValue = (value) => {
        const numericValue = parseFloat(value || 0);
        return numericValue.toFixed(2);
    };

    const chartData = [
        {
            name: "Nursing HPPD",
            data: [
                {
                    x: "Actual",
                    y: parseFloat(formatValue(currentFacility?.details?.["Nursing HPPD- Actual"] ||
                        currentFacility?.details?.["Nursing HPPD - Actual"])),
                    fillColor: "#405F78"
                },
                {
                    x: "Expected",
                    y: parseFloat(formatValue(currentFacility?.details?.["Nursing HPPD- Expected"] ||
                        currentFacility?.details?.["Nursing HPPD - Expected"])),
                    fillColor: "#755263"
                },
                {
                    x: "Weekend",
                    y: parseFloat(formatValue(currentFacility?.details?.["Nursing HPPD- Weekend"] ||
                        currentFacility?.details?.["Nursing HPPD - Weekend"])),
                    fillColor: "#f0b41c"
                },
            ]
        }
    ];

    const chartLabels = ["Actual", "Expected", "Weekend"];

    const chartOptions = {
        chart: {
            type: "bar",
            toolbar: {
                show: false
            },
            animations: {
                enabled: true,
                easing: 'easeinout',
                speed: 800,
                animateGradually: {
                    enabled: true,
                    delay: 150
                },
                dynamicAnimation: {
                    enabled: true,
                    speed: 350
                }
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "55%",
                borderRadius: 6,
                borderRadiusApplication: "end",
                distributed: true,
                dataLabels: {
                    position: 'top'
                }
            }
        },
        dataLabels: {
            enabled: true,
            formatter: function (val) {
                return val.toFixed(2);
            },
            offsetY: -20,
            offsetX: -10,
            style: {
                fontSize: '12px',
                fontWeight: '600',
                colors: ["#404040"]
            }
        },
        legend: {
            show: false
        },
        grid: {
            show: true,
            borderColor: '#f1f1f1',
            strokeDashArray: 4,
            position: 'back'
        },
        xaxis: {
            categories: chartLabels,
            labels: {
                style: {
                    fontSize: '12px',
                    fontWeight: 500
                }
            },
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false
            }
        },
        yaxis: {
            labels: {
                formatter: function (val) {
                    return val.toFixed(1);
                },
                style: {
                    fontSize: '12px'
                }
            }
        },
        tooltip: {
            enabled: true,
            theme: 'dark',
            y: {
                formatter: function (val) {
                    return val.toFixed(2) + ' HPPD';
                }
            }
        },
        colors: ["#405F78", "#755263", "#f0b41c"]
    };

    return (
        <Card extra={"items-center justify-around w-full p-[16px] bg-cover flex flex-col"}>
            <h3 className="ml-3 text-med self-start font-bold text-gray-700 dark:text-white">
                Nursing HPPD
            </h3>
            {noData ? (
                <p>No data available</p>
            ) : (
                <div className="w-full h-[300px]">
                    <BarChart
                        chartData={chartData}
                        chartOptions={chartOptions}
                        height="100%"
                        width="100%"
                    />
                </div>
            )}
        </Card>
    );
};

export default NursingHPPD;